import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/**
 * Reusable checkbox — wraps MUI Checkbox with a consistent label layout.
 */
export function Checkbox({ label, checked, onChange, disabled }: CheckboxProps) {
  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          size="small"
          checked={checked}
          onChange={(_e, val) => onChange(val)}
          disabled={disabled}
        />
      }
      label={label}
      slotProps={{ typography: { variant: 'body1' } }}
    />
  );
}
